import type { ProfileInfoConfig } from '../../profileInfo.types.ts';

const PROFILE_INFO: ProfileInfoConfig = {
  isShowDetailedNameChangeVerification: false,
  nameChangeKycVerificationMethods: [{ name: 'manual-upload' }],
  nameChangeKycDialogTitleKey: 'title',
  isUseNameChangeManualUploadCopy: false,
};

export { PROFILE_INFO };
